// extracted by mini-css-extract-plugin
module.exports = {"link":"SocialMediaLink_link__2IxSB","p":"SocialMediaLink_p__M81Mz"};